/**
 * Created by apokdev on 6/6/17.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { hideHeader } from "../constants/functions";
import { getJSON } from '../constants/network';
import routes from '../constants/routes';
import PoiMap from './PoiMap';
import PoiImagenes from './PoiImagenes';
import BreadCrumb from './Breadcrumbs';
import ListaServicios from './ListaServicios';
import Regiones from './Regiones';
import SlickPoi from './SlickPoi';

import jQuery from 'jquery';

let $ = window.$ = window.jQuery = jQuery;

export default class extends Component {
    constructor() {
        super();
        this.mapVisible = false;
        this.galleryVisible = false;
        this.state = {
            data: {
                data: {
                    imagenes: [],
                    sector: {},
                    tipo: {},
                    region: {
                        slug: ''
                    }
                }
            },
            otrosPoi: {
                tipo: {}, pois: []
            }
        };
        this.ocultarTodo = this.ocultarTodo.bind(this);
        this.fixSize = this.fixSize.bind(this);
        this.mostrarFavoritoDestacado = this.mostrarFavoritoDestacado.bind(this);
        this.mostrarMapa = this.mostrarMapa.bind(this);
        this.mostrarImagenes = this.mostrarImagenes.bind(this);
        this.cargarMapa = this.cargarMapa.bind(this);
        this.cargarImagenes = this.cargarImagenes.bind(this);
        this.linksTabs = this.linksTabs.bind(this);
    }

    loadPoiFromServer(url) {
        let tipo, sector, estado;
        getJSON(url)
            .then(result => {
                this.setState({data: result});
                tipo = result.data.tipo;
                sector = result.data.sector;
                estado = sector.estado || result.data.ruta.estado;
                return getJSON(routes.poiAll + "/tipo/" + tipo.slug + "/estado/" + estado + "?exclude=" + result.data.id);
            })
            .then(result2 => {
                this.setState({
                    otrosPoi: {tipo: tipo, pois: result2.data}
                });
            })
    }

    componentDidMount() {
        let url = routes.poiById + this.props.match.params.poiId;
        this.loadPoiFromServer(url);

        hideHeader();

        this.mostrarMapa(false);
        this.mostrarImagenes(false);
    }

    componentDidUpdate(prevProps) {
        hideHeader();
        let oldId = prevProps.match.params.poiId;
        let newId = this.props.match.params.poiId;
        if (newId !== oldId) {
            let url = routes.poiById + this.props.match.params.poiId;
            this.loadPoiFromServer(url)
        }
        ReactDOM.unmountComponentAtNode(document.getElementById('mapa-poi'));
        ReactDOM.unmountComponentAtNode(document.getElementById('imagenes-poi'));

        if (this.mapVisible) {
            this.cargarMapa();
        }
        if (this.galleryVisible) {
            this.cargarImagenes();
        }
    }

    mostrarMapa(mostrar) {
        this.mapVisible = mostrar;
    }

    mostrarImagenes(mostrar) {
        this.galleryVisible = mostrar;
    }

    cargarMapa() {
        this.mostrarMapa(true);
        this.mostrarImagenes(false);
        let data = this.state.data.data;
        ReactDOM.render(<PoiMap poi={data}/>, document.getElementById('mapa-poi'));
    }

    cargarImagenes() {
        this.mostrarMapa(false);
        this.mostrarImagenes(true);
        let data = this.state.data.data;
        ReactDOM.render(<PoiImagenes imagenes={data.imagenes}/>, document.getElementById('imagenes-poi'));
    }

    ocultarTodo() {
        this.mostrarImagenes(false);
        this.mostrarMapa(false);
    }

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(document.getElementById('mapa-poi'));
        ReactDOM.unmountComponentAtNode(document.getElementById('imagenes-poi'));
    }

    linksTabs(data, extras) {
        let codigo = [];

        if (data.observaciones || data.comentarios) {
            codigo.push(
                <li key="tab-descripcion" role="presentation" className="active">
                    <a href="#observaciones-poi"
                       data-toggle="tab"
                       onClick={() => {
                           this.ocultarTodo();
                           this.fixSize('observaciones-poi')
                       }}>Descripción</a>
                </li>
            );
        }

        if (data.imagenes && data.imagenes.length > 0) {
            codigo.push(
                <li key="tab-imagenes" role="presentation">
                    <a href="#imagenes-poi" onClick={this.cargarImagenes}
                       data-toggle="tab">Imagenes</a>
                </li>
            );
        }

        if (data.latitud !== 0 && data.longitud !== 0) {
            codigo.push(
                <li key="tab-mapa" role="presentation">
                    <a href="#mapa-poi" data-toggle="tab" onClick={this.cargarMapa}>Mapa</a>
                </li>
            );
        }

        if (extras.length) {
            codigo.push(
                <li key="tab-info" role="presentation">
                    <a href="#informacion-poi" data-toggle="tab" onClick={this.ocultarTodo}>Información</a>
                </li>
            );
        }

        return codigo;
    }

    fixSize(tabToResize) {
        let tabCount = $(".tab-menu .nav-stacked li").length;
        let tabHeight = $(".tab-menu .nav-stacked li:first").height();
        let minHeight = tabCount * tabHeight;
        $(".tab-content").css("minHeight", `${minHeight}px`);
    }

    mostrarFavoritoDestacado(data) {
        let codigo = [];
        if (data.destacado) {
            codigo.push(
                <p key="dest">
                    <i className="destacado-icon glyphicon glyphicon-bookmark"/>&nbsp;Punto Destacado
                </p>
            )
        }
        if (data.favorito) {
            codigo.push(
                <p key="fav">
                    <i className="favorito-icon glyphicon glyphicon-heart"/>&nbsp;Favorito de Valentina
                </p>
            );
        }

        if (data.favorito || data.destacado) {
            return (
                <div className="favorito-destacado2">
                    {codigo}
                </div>
            )
        }
        return <div/>;
    }

    render() {
        let imagen = '/img/brujula_oficial_gris.png';
        let _this = this;
        if (this.state.data) {
            let data = this.state.data.data;

            if (data.imagenes && data.imagenes.length !== 0) {
                imagen = data.imagenes[0].thumbnail;
            }

            let extras = [];
            if (data.extras) {
                for (let name in data.extras) {
                    if (data.extras[name]) {
                        extras.push(name);
                    }
                }
            }

            let regionSlug = (data.region) ? data.region.slug : '';
            return (<div>
                <div id="cambio-sector" className={regionSlug}>
                    <div className="contenedor-sector">
                        <BreadCrumb links={[
                            {url: `/#/estado/${data.sector.estado}`, text: data.sector.estado},
                            {url: `/#/estado/${data.sector.estado}/${data.tipo.slug}`, text: data.tipo.nombre},
                            {url: "", text: data.nombre}
                        ]}/>
                    </div>
                </div>
                <div className="contenedor-sector">
                    <div className="row">
                        <div className="poi-container col-sm-12">
                            <p className="link_volver">
                                <a onClick={() => this.props.history.goBack()}>
                                    <span className="glyphicon glyphicon-triangle-left"/>
                                    &nbsp;Volver
                                </a>
                            </p>
                            <div className="poi-info media">
                                <div className="media-left">
                                    <div className="thumbnail">
                                        <img src={imagen} alt=""/>
                                    </div>
                                </div>
                                <div className="media-body">
                                    <h2 className="media-heading">{data.nombre}</h2>
                                    {
                                        (function () {
                                            let info = [];
                                            if (data.habitaciones !== 0) {
                                                info.push(
                                                    <p key={"info-hab"}><b>{data.habitaciones} Habitaciones</b></p>
                                                )
                                            }
                                            if (data.direccion) {
                                                info.push(<p key={"info-direccion"}><b>Dirección: </b> {data.direccion}
                                                </p>);
                                            }
                                            if (data.telefono) {
                                                let telfs = data.telefono.split(",");
                                                telfs.forEach((telf, index) => {
                                                    telf = telf.trim();
                                                    let icono = (<i className="fa fa-fw fa-2x fa-vertical-center"/>)
                                                    if (index === 0) {
                                                        icono = (
                                                            <i className="fa fa-phone-square fa-fw fa-2x fa-vertical-center"/>);
                                                    }
                                                    info.push(
                                                        <p key={`info-telf${index}`}>
                                                            {icono}
                                                            {telf}
                                                        </p>
                                                    );
                                                });
                                            }
                                            if (data.email) {
                                                let emails = data.email.split(",");
                                                emails.forEach((email, index) => {
                                                    email = email.trim();
                                                    let icono = (<i className="fa fa-fw fa-2x fa-vertical-center"/>);

                                                    if (index === 0) {
                                                        icono = (
                                                            <i className="fa fa-envelope-o fa-fw fa-2x fa-vertical-center"/>);
                                                    }
                                                    info.push(
                                                        <p key={`info-mail${index}`}>
                                                            {icono}
                                                            <a href={"mailto:" + email}>{email}</a>
                                                        </p>
                                                    );
                                                });
                                            }
                                            if (data.url) {
                                                let url = data.url;
                                                if (!url.startsWith("http")) {
                                                    url = `http://${url}`;
                                                }
                                                info.push(<p key={"info-web"}><b>WEB: </b> <a
                                                    href={url} target="_blank" rel="noopener noreferrer">{url}</a></p>);
                                            }
                                            if (data.facebook) {
                                                info.push(
                                                    <p key={"info-fb"}>
                                                        <i className="fa fa-facebook-official fa-fw fa-2x fa-vertical-center"/>
                                                        <a href={data.facebook} target="_blank" rel="noopener noreferrer">{data.facebook}</a>
                                                    </p>
                                                );
                                            }
                                            if (data.twitter) {
                                                let twitterUrl = "http://www.twitter.com/" + data.twitter;
                                                info.push(
                                                    <p key={"info-twitter"}>
                                                        <i className="fa fa-twitter-square fa-fw fa-2x fa-vertical-center"/>
                                                        <a href={twitterUrl} target="_blank" rel="noopener noreferrer">{data.twitter}</a>
                                                    </p>
                                                );
                                            }
                                            if (data.instagram) {
                                                let instaUrl = "http://www.instagram.com/" + data.instagram.replace("@", "");
                                                info.push(
                                                    <p key={"info-insta"}>
                                                        <i className="fa fa-instagram fa-fw fa-2x fa-vertical-center"/>
                                                        <a href={instaUrl} target="_blank" rel="noopener noreferrer">{data.instagram}</a>
                                                    </p>
                                                );
                                            }
                                            return info;
                                        })()
                                    }
                                </div>
                                <div className="media-right hidden-xs">
                                    {
                                        (function () {
                                            if (data.servicios && data.servicios.length) {
                                                return (<ListaServicios servicios={data.servicios}/>);
                                            }
                                        })()
                                    }
                                    {/*<PoiRating rating={data.valoracion}/>*/}
                                    {this.mostrarFavoritoDestacado(data)}
                                </div>
                                <div className="visible-xs">
                                    {
                                        (function () {
                                            if (data.servicios && data.servicios.length) {
                                                return (<ListaServicios servicios={data.servicios}/>);
                                            }
                                        })()
                                    }
                                    {/*<PoiRating rating={data.valoracion}/>*/}
                                    {this.mostrarFavoritoDestacado(data)}
                                </div>
                            </div>

                            <div className="poi-detalle row">
                                <div className="contenedor-tabs">
                                    <div className="col-sm-12">
                                        <div className="col-sm-12">
                                            <div className="tab-menu col-sm-3 col-xs-12">
                                                <ul className="tabs-info-poi nav nav-pills nav-stacked hidden-xs">
                                                    {this.linksTabs(data, extras)}
                                                </ul>
                                                <ul className="tabs-info-poi-mobile nav nav-pills visible-xs">
                                                    {this.linksTabs(data, extras)}
                                                </ul>
                                            </div>
                                            <div className="tab-content col-sm-9 col-xs-12">
                                                {
                                                    (function () {
                                                        if (data.observaciones || data.comentarios) {
                                                            let texto = "";
                                                            if (data.observaciones) {
                                                                texto += data.observaciones + "<p>&nbsp;</p>";
                                                            }
                                                            if (data.comentarios) {
                                                                texto += data.comentarios;
                                                            }
                                                            return <div id="observaciones-poi"
                                                                        className="tab-pane active"
                                                                        dangerouslySetInnerHTML={{__html: texto}}/>
                                                        }
                                                    })()
                                                }
                                                <div id="imagenes-poi" className="tab-pane"/>
                                                <div id="mapa-poi"  className="tab-pane"/>

                                                {
                                                    (function () {
                                                        if (extras.length) {
                                                            return (
                                                                <div id="informacion-poi" className="tab-pane">
                                                                    {
                                                                        extras.map(function (extra) {
                                                                            if (data.extras[extra]) {
                                                                                return (
                                                                                    <div key={extra}>
                                                                                        <h3>{extra}</h3>
                                                                                        <div
                                                                                            dangerouslySetInnerHTML={{__html: data.extras[extra]}}/>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            return null;
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    })()
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="link_volver">
                                <a onClick={() => this.props.history.goBack()}>
                                    <span className="glyphicon glyphicon-triangle-left"/>
                                    &nbsp;Volver
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="slick-otros-poi">
                    {
                        (function () {
                            if (_this.state.otrosPoi.pois.length) {
                                return (
                                    <SlickPoi
                                        titulo={"Más " + _this.state.otrosPoi.tipo.nombre}
                                        tituloClass={{"textAlign": "right"}}
                                        id={"slick_" + data.id}
                                        poi={_this.state.otrosPoi}
                                        region={regionSlug}
                                        slides={4}
                                        vertical={false}/>
                                );
                            }
                        })()
                    }
                </div>

                <div className="include-region">
                    <Regiones completo={false}/>
                </div>
            </div>)
        } else {
            return ( <b>Cargando...</b>)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/PoiInfo.js